import md5 from 'js-md5'

import { checkAxiosData, getAxiosConfig } from 'fe-common'
import { from, concatMap, merge, filter, tap, zip } from 'rxjs'
import {
  amountStr2Arr,
  handleMessages,
  refreshToken
} from '../../modules/client/utilities'

// eslint-disable-next-line standard/computed-property-even-spacing
const comp = require(`../../${process.env.TEMPLATE_ID}/comp.json`)[
  process.env.COMP_ID
]

export const LANG_TO_COUNTRY_REGEX = /^(?:(en-GB-oed|i-ami|i-bnn|i-default|i-enochian|i-hak|i-klingon|i-lux|i-mingo|i-navajo|i-pwn|i-tao|i-tay|i-tsu|sgn-BE-FR|sgn-BE-NL|sgn-CH-DE)|(art-lojban|cel-gaulish|no-bok|no-nyn|zh-guoyu|zh-hakka|zh-min|zh-min-nan|zh-xiang))$|^((?:[a-z]{2,3}(?:(?:-[a-z]{3}){1,3})?)|[a-z]{4}|[a-z]{5,8})(?:-([a-z]{4}))?(?:-([a-z]{2}|\d{3}))?((?:-(?:[\da-z]{5,8}|\d[\da-z]{3}))*)?((?:-[\da-wy-z](?:-[\da-z]{2,8})+)*)?(-x(?:-[\da-z]{1,8})+)?$|^(x(?:-[\da-z]{1,8})+)$/i

export function getUserVenusPointAccount(rootState) {
  const result = rootState.authModule.user.thirdPaymentList.find(
    thirdPayment =>
      rootState.userFinancialServiceModule.selectedDepositType.key ===
      thirdPayment.opId
  )
  return result && result.thirdAccount
}

export function getCurrencyExchangeRate(rootState, type) {
  // 對日幣(JPY)
  // type: deposit, withdrawal
  let currencyExchangeRate = 1
  if (rootState.authModule.user.userCurrency.toUpperCase() === 'USD') {
    switch (process.env.COMP_ID) {
      case 'yc':
      case 'wc':
        if (type === 'deposit') {
          currencyExchangeRate = 113
        } else {
          currencyExchangeRate = 109
        }
        break
      default:
        currencyExchangeRate = 105
        break
    }
  }
  return currencyExchangeRate
}

const convertDepositType = item => ({
  key: item.id,
  name: item.platformType,
  type: item.type,
  typeId: item.typeId,
  minLimitPrice: item.lowerlimit,
  maxLimitPrice: item.upperlimit,
  feeRate: item.rate4player,
  fixedAmounts: item.fixedAmount,
  fixedAmountCurrency: item.fixedAmountCurrency,
  vendor: item.vendor,
  hasFeeRate: item.showFee,
  isFeeShowZero: item.feeEqualZero,
  exchangeRateJPY: item.exchangeRateJPY, // 顯示用
  exchangeRate: item.exchangeRate,
  displayName: item.alias,
  showName: item.displayName, // for thirdPayment subtype
  // for thirdPayment bankcard
  depositNo: item.billno,
  referenceNo: item.referenceNo,
  bankCode: item.bankCode,
  branchCode: item.branchCode,
  cardNo: item.cardNo,
  showPicture: item.showPicture
})

export default {
  namespaced: true,
  state: () => ({
    // deposit
    depositChannels: [],
    selectedDepositChannel: null,

    depositTypes: [],
    selectedDepositType: null,

    depositSubTypes: [],
    selectedDepositSubType: null,

    depositBanks: [], // ebank channel / thirdPayment type to used
    selectedDepositBank: null, // ebank channel / thirdPayment type to used

    depositBankSubTypes: [], // 銀行子渠道
    selectedDepositBankSubType: null,

    depositBankCardInfoList: [], // 存款銀行清單
    selectedDepositBankCardInfo: {},

    selectedDepositUserBankInfo: null, // 玩家目前選擇的個人銀行卡

    depositBankCardInfoTransferInBankList: [], // 轉入銀行
    selectedDepositBankCardInfoTransferInBank: null,

    selectedDepositBankCardInfoType: null, // 存款方式

    depositBankCardInfoCreateTime: null, // 訂單時間

    depositProducts: [], // echolonpay 圖片列表
    selectedDepositProduct: null,
    isDepositProductLoading: null,

    depositCreditCardCVV: null, // credit card
    depositCreditCardExpirationMonth: null,
    depositCreditCardExpirationYear: null,
    depositCreditCardHolderFirstName: null,
    depositCreditCardHolderLastName: null,
    depositCreditCardNumber: null,
    depositCreditCardState: null,
    depositCreditCardCity: null,
    depositCreditCardPostalCode: null,
    depositCreditCardStreet: null,
    depositCreditCardPhone: null, // for wonderlandpay
    depositCreditCardEmail: null, // for wonderlandpay
    depositCreditCardScriptSrc: null, // for wonderlandpay
    depositCreditCardUniqueId: null, // for wonderlandpay
    depositCreditCardDeviceNo: null, // for wonderlandpay,
    depositCreditCardSaveCreditCard: false, // 是否要儲存信用卡
    depositCreditCardPaymentType: 'common', // common:常用，manual:手動
    selectedDepositUserCreditCard: null,
    depositCreditCardType: null,

    depositVenusPointAccount: null, // venus point
    depositVenusPointPassword: null,

    depositVEGAAccount: null, // VEGA
    depositVEGAPassword: null,

    depositFirstName: null, // vCurrency | thirdPayment | EcoPayz | Payz
    depositLastName: null,

    depositVCurrencyTypes: ['BTC', 'ETH', 'LTC'], // vCurrency - Coinbase
    selectedDepositVCurrencyType: null,
    depositVCurrencyExchangeQuantity: null, // 金額兌換的虛擬幣數量
    depositVCurrencyRate: null,

    depositMinLimitPrice: null,
    depositMaxLimitPrice: null,

    depositPrices: [],
    depositPriceCurrency: null,
    selectedDepositPrice: null,
    depositPriceSelectOnly: false, // 是否僅可選擇金額，不可任意輸入

    depositBankCardInfoDepositName: null, // 收款姓名
    depositPrice: null,
    depositVCurrencyDestinationTag: null,
    depositExchangeRate: null, // 金額匯率
    depositDisplayExchangeRate: null, // 顯示匯率用

    depositFeeRate: null, // 手續費 (單位：百分比)

    // withdrawal
    thirdPaymentPassword: null, // 密碼 (Venus Point)
    payPassword: null,
    withdrawalPrice: null,
    withdrawalPrices: [],
    withdrawalVCurrencyDestinationTag: null,
    withdrawalTypes: [
      { key: 'bankcard', name: '銀行卡', value: 'bankcard' },
      { key: 'thirdPayment', name: '第三方支付', value: 'thirdPayment' }
    ],
    selectedWithdrawalType: null,
    selectedWithdrawalThirdPayment: null,
    selectedWithdrawalBankCard: null,
    withdrawalFormFields: [], // 依據 api 回傳決定 form 表單欄位集合
    withdrawalThirdPaymentSubTypes: [], // 提款子渠道
    selectedWithdrawalThirdPaymentSubType: null,
    withdrawalFeeRate: null, // 手續費 (單位：百分比)
    hasWithdrawalFeeRate: false,
    withdrawalExchangeRate: null, // 金額匯率
    isWithdrawalFeeRateShowZero: false, // 手續費是否秀 0

    withdrawalVCurrencyExchangeQuantity: null, // 金額兌換的虛擬幣數量
    withdrawalVCurrencyRate: null,

    withdrawalFirstName: null,
    withdrawalLastName: null,

    // transfer
    selectedTransferOutWallet: null,
    selectedTransferInWallet: null,
    transferPrice: null
  }),
  actions: {
    //
    // common
    //
    getVCurrencyExchangeInfo(context, { data = {}, config = {} }) {
      const { commit } = context
      let urlParams = ''
      if ($nuxt.$route.path.startsWith('/user/financial-service/deposit')) {
        urlParams = 'DEPOSIT'
      } else if (
        $nuxt.$route.path.startsWith('/user/financial-service/withdrawal')
      ) {
        urlParams = 'WITHDRAW'
      }
      commit('DEPOSIT_V_CURRENCY_RATE', null)
      commit('DEPOSIT_V_CURRENCY_EXCHANGE_QUANTITY', null)
      commit('WITHDRAWAL_V_CURRENCY_RATE', null)
      commit('WITHDRAWAL_V_CURRENCY_EXCHANGE_QUANTITY', null)
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/payment/getExchangeRate${
                  urlParams ? `/${urlParams}` : ''
                }`,
                data,
                getAxiosConfig(context, { timeout: 30 * 1000, ...config })
              )
            )
          )
        )
        .toPromise()
    },

    //
    // deposit
    //
    initDepositData({ commit, rootState }) {
      commit('DEPOSIT_TYPES', [])
      commit('SELECTED_DEPOSIT_TYPE', null)
      commit('DEPOSIT_SUB_TYPES', [])
      commit('SELECTED_DEPOSIT_SUB_TYPE', null)
      commit('DEPOSIT_BANKS', [])
      commit('SELECTED_DEPOSIT_BANK', null)
      commit('DEPOSIT_BANK_SUB_TYPES', [])
      commit('SELECTED_DEPOSIT_BANK_SUB_TYPE', null)
      commit('DEPOSIT_BANK_CARD_INFO_LIST', [])
      commit('SELECTED_DEPOSIT_BANK_CARD_INFO', {})
      commit('SELECTED_DEPOSIT_USER_BANK_INFO', null)
      commit('DEPOSIT_BANK_CARD_INFO_TRANSFER_IN_BANK_LIST', [])
      commit('SELECTED_DEPOSIT_BANK_CARD_INFO_TRANSFER_IN_BANK', null)
      commit('SELECTED_DEPOSIT_BANK_CARD_INFO_TYPE', '0')
      commit('DEPOSIT_BANK_CARD_INFO_CREATE_TIME', null)
      commit('DEPOSIT_PRODUCTS', [])
      commit('SELECTED_DEPOSIT_PRODUCT', null)
      commit('IS_DEPOSIT_PRODUCT_LOADING', false)
      commit('DEPOSIT_CREDIT_CARD_CVV', null)
      commit('DEPOSIT_CREDIT_CARD_EXPIRATION_MONTH', null)
      commit('DEPOSIT_CREDIT_CARD_EXPIRATION_YEAR', null)
      commit('DEPOSIT_CREDIT_CARD_HOLDER_FIRST_NAME', null)
      commit('DEPOSIT_CREDIT_CARD_HOLDER_LAST_NAME', null)
      commit('DEPOSIT_CREDIT_CARD_NUMBER', null)
      commit('DEPOSIT_CREDIT_CARD_CITY', null)
      commit('DEPOSIT_CREDIT_CARD_STATE', null)
      commit('DEPOSIT_CREDIT_CARD_POSTAL_CODE', null)
      commit('DEPOSIT_CREDIT_CARD_STREET', null)
      commit('DEPOSIT_CREDIT_CARD_PHONE', null)
      commit('DEPOSIT_CREDIT_CARD_EMAIL', null)
      commit('DEPOSIT_CREDIT_CARD_SCRIPT_SRC', null)
      commit('DEPOSIT_CREDIT_CARD_UNIQUE_ID', null)
      commit('DEPOSIT_CREDIT_CARD_DEVICE_NO', null)
      commit('DEPOSIT_CREDIT_CARD_SAVE_CREDIT_CARD', false)
      commit('DEPOSIT_CREDIT_CARD_PAYMENT_TYPE', 'common')
      commit('SELECTED_DEPOSIT_USER_CREDIT_CARD', null)
      commit('DEPOSIT_CREDIT_CARD_TYPE', null)
      commit('DEPOSIT_VENUS_POINT_ACCOUNT', null)
      commit('DEPOSIT_VENUS_POINT_PASSWORD', null)
      commit('DEPOSIT_VEGA_ACCOUNT', null)
      commit('DEPOSIT_VEGA_PASSWORD', null)
      commit('DEPOSIT_FIRST_NAME', null)
      commit('DEPOSIT_LAST_NAME', null)
      commit('SELECTED_DEPOSIT_V_CURRENCY_TYPE', null)
      commit('DEPOSIT_V_CURRENCY_EXCHANGE_QUANTITY', null)
      commit('DEPOSIT_V_CURRENCY_RATE', null)
      commit('DEPOSIT_MIN_LIMIT_PRICE', null)
      commit('DEPOSIT_MAX_LIMIT_PRICE', null)
      commit('DEPOSIT_PRICES', [])
      commit('SELECTED_DEPOSIT_PRICE', null)
      commit('DEPOSIT_PRICE_SELECT_ONLY', false)
      commit('DEPOSIT_PRICE_CURRENCY', null)
      commit('DEPOSIT_BANK_CARD_INFO_DEPOSIT_NAME', null)
      commit('DEPOSIT_PRICE', null)
      commit('DEPOSIT_V_CURRENCY_DESTINATION_TAG', null)
      commit('DEPOSIT_EXCHANGE_RATE', null)
      commit('DEPOSIT_DISPLAY_EXCHANGE_RATE', null)
      commit('DEPOSIT_FEE_RATE', null)
    },
    selectDepositChannel(context, payload) {
      const { state, dispatch, commit } = context
      commit('SELECTED_DEPOSIT_CHANNEL', payload)
      return from(refreshToken(context))
        .pipe(
          concatMap(() => from(dispatch('initDepositData'))),
          concatMap(() =>
            state.selectedDepositChannel === 'bankcard'
              ? zip(
                  from(dispatch('getDepositBankCardInfoList')),
                  from(
                    dispatch('getDepositBankCardInfoTransferInBankList')
                  ).pipe(
                    filter(data =>
                      checkAxiosData(data, {
                        handleMessages: handleMessages({
                          store: context
                        })
                      })
                    ),
                    tap(({ data }) => {
                      commit(
                        'DEPOSIT_BANK_CARD_INFO_TRANSFER_IN_BANK_LIST',
                        data
                      )
                    })
                  )
                )
              : from(Promise.resolve())
          ),
          concatMap(() => from(dispatch('getDepositTypes')))
        )
        .toPromise()
    },
    selectDepositType({ commit, state, dispatch, rootState }, payload) {
      commit('SELECTED_DEPOSIT_TYPE', payload)

      commit('DEPOSIT_EXCHANGE_RATE', payload.exchangeRate)
      commit('DEPOSIT_DISPLAY_EXCHANGE_RATE', payload.exchangeRateJPY)

      commit('DEPOSIT_SUB_TYPES', [])
      commit('SELECTED_DEPOSIT_SUB_TYPE', null)

      return merge(
        from(dispatch('selectDepositUserBankInfo')),
        from(
          (() => {
            if (payload.type === 'bankcard') {
              return dispatch('getDepositBankCardSubTypes')
            }
            if (payload.key === 0 && payload.typeId) {
              return dispatch('getDepositSubTypes', { id: payload.typeId })
            }

            return dispatch('updateDepositTypeData', state.selectedDepositType)
          })()
        )
      ).toPromise()
    },
    selectDepositUserBankInfo({ commit, rootState }, payload) {
      // 沒有在維護中
      const userBankList = rootState.authModule.user.bankList.filter(
        bank => !bank.isMaintain
      )
      commit(
        'SELECTED_DEPOSIT_USER_BANK_INFO',
        payload || (userBankList.length > 0 ? userBankList[0] : null)
      )
    },
    selectDepositSubType({ commit, state, dispatch, rootState }, payload) {
      commit('SELECTED_DEPOSIT_SUB_TYPE', payload)

      commit('DEPOSIT_EXCHANGE_RATE', state.selectedDepositSubType.exchangeRate)
      commit(
        'DEPOSIT_DISPLAY_EXCHANGE_RATE',
        state.selectedDepositSubType.exchangeRateJPY
      )

      return dispatch('updateDepositTypeData', state.selectedDepositSubType)
    },
    selectDepositBankSubType(context, payload) {
      const { commit, dispatch } = context
      const { excludeUpdateFields, ...depositType } = payload
      commit('SELECTED_DEPOSIT_BANK_SUB_TYPE', depositType)
      commit('DEPOSIT_BANK_CARD_INFO_LIST', [])
      commit('SELECTED_DEPOSIT_BANK_CARD_INFO', {})

      return dispatch('updateDepositTypeData', payload)
    },
    updateDepositTypeData(context, payload) {
      const { commit, state, dispatch, rootState } = context

      const { excludeUpdateFields = [], ...depositType } = payload

      if (!excludeUpdateFields.includes('depositPrice')) {
        commit('DEPOSIT_PRICE', null)
      }

      commit('DEPOSIT_PRICES', [])
      commit('SELECTED_DEPOSIT_PRICE', null)
      commit('DEPOSIT_CREDIT_CARD_SCRIPT_SRC', null)

      if (
        !state.selectedDepositChannel ||
        (state.selectedDepositChannel &&
          state.selectedDepositChannel !== 'bankcard')
      ) {
        commit('DEPOSIT_MIN_LIMIT_PRICE', depositType.minLimitPrice)
        commit('DEPOSIT_MAX_LIMIT_PRICE', depositType.maxLimitPrice)
      }
      if (depositType.fixedAmounts) {
        commit('DEPOSIT_PRICES', amountStr2Arr(depositType.fixedAmounts))
        commit('DEPOSIT_PRICE_SELECT_ONLY', true)
      } else {
        commit('DEPOSIT_PRICE_SELECT_ONLY', false)
      }
      commit('DEPOSIT_PRICE_CURRENCY', depositType.fixedAmountCurrency)
      commit('DEPOSIT_FEE_RATE', depositType.feeRate)
      commit('SELECTED_DEPOSIT_BANK', null)

      if (
        state.selectedDepositChannel &&
        state.selectedDepositChannel === 'ebank'
      ) {
        return from(dispatch('getDepositBanks'))
          .pipe(
            filter(data =>
              checkAxiosData(data, {
                handleMessages: handleMessages({
                  store: context
                })
              })
            ),
            tap(({ data }) => {
              commit(
                'DEPOSIT_BANKS',
                data
                  ? data.map(item => ({
                      key: item.value,
                      name: item.name
                    }))
                  : []
              )
            })
          )
          .toPromise()
      }

      if (depositType.type === 'creditCard') {
        commit('DEPOSIT_CREDIT_CARD_CVV', null)
        commit('DEPOSIT_CREDIT_CARD_EXPIRATION_MONTH', null)
        commit('DEPOSIT_CREDIT_CARD_EXPIRATION_YEAR', null)
        commit('DEPOSIT_CREDIT_CARD_HOLDER_FIRST_NAME', null)
        commit('DEPOSIT_CREDIT_CARD_HOLDER_LAST_NAME', null)
        commit('DEPOSIT_CREDIT_CARD_NUMBER', null)
        commit('DEPOSIT_CREDIT_CARD_CITY', null)
        commit('DEPOSIT_CREDIT_CARD_STATE', null)
        commit('DEPOSIT_CREDIT_CARD_POSTAL_CODE', null)
        commit('DEPOSIT_CREDIT_CARD_STREET', null)
        commit('DEPOSIT_CREDIT_CARD_PHONE', null)
        commit('DEPOSIT_CREDIT_CARD_EMAIL', null)
        commit('DEPOSIT_CREDIT_CARD_UNIQUE_ID', null)
        commit('DEPOSIT_CREDIT_CARD_DEVICE_NO', null)
        commit('DEPOSIT_CREDIT_CARD_SAVE_CREDIT_CARD', false)
        commit('SELECTED_DEPOSIT_USER_CREDIT_CARD', null)
        commit('DEPOSIT_CREDIT_CARD_TYPE', null)

        const userCreditCardList = rootState.authModule.user.creditCardList.filter(
          creditCard => {
            const result = depositType.name === creditCard.cardType

            if (!['mc'].includes(process.env.COMP_ID)) {
              return result && creditCard.status === 'ENABLE'
            }

            return result
          }
        )
        commit(
          'SELECTED_DEPOSIT_USER_CREDIT_CARD',
          userCreditCardList[0] || null
        )

        if (!['mc'].includes(process.env.COMP_ID)) {
          commit('DEPOSIT_CREDIT_CARD_PAYMENT_TYPE', 'common')
        } else if (!state.selectedDepositUserCreditCard) {
          commit('DEPOSIT_CREDIT_CARD_PAYMENT_TYPE', 'manual')
        }

        return from(dispatch('userModule/getCountries', null, { root: true }))
          .pipe(
            tap(countries => {
              commit(
                'userModule/SELECTED_COUNTRY',
                countries.find(
                  ({ countryCode }) =>
                    countryCode === process.env.DEFAULT_COUNTRY
                )?.countryCode || null,
                { root: true }
              )
            }),
            concatMap(() =>
              from(
                dispatch('getCustomPaymentInfo', {
                  id: depositType.key
                })
              )
            ),
            // 因 res.data 回傳可能為字串
            // filter(data =>
            //   checkAxiosData(data, {
            //     handleMessages: handleMessages({
            //       store: context
            //     })
            //   })
            // ),
            filter(data => data),
            tap(({ scriptSrc, uniqueId }) => {
              commit('DEPOSIT_CREDIT_CARD_SCRIPT_SRC', scriptSrc)
              commit('DEPOSIT_CREDIT_CARD_UNIQUE_ID', uniqueId)
            })
          )
          .toPromise()
      }

      if (depositType.name === 'VENUS-POINT') {
        commit(
          'DEPOSIT_VENUS_POINT_ACCOUNT',
          getUserVenusPointAccount(rootState)
        )
        commit('DEPOSIT_VENUS_POINT_PASSWORD', null)
      }

      if (depositType.name === 'VEGA') {
        commit('DEPOSIT_VEGA_ACCOUNT', getUserVenusPointAccount(rootState))
        commit('DEPOSIT_VEGA_PASSWORD', null)
      }

      if (depositType.type === 'vCurrency') {
        commit('DEPOSIT_FIRST_NAME', null)
        commit('DEPOSIT_LAST_NAME', null)
        commit('DEPOSIT_V_CURRENCY_EXCHANGE_QUANTITY', null)
        commit('DEPOSIT_V_CURRENCY_DESTINATION_TAG', null)
        commit('DEPOSIT_V_CURRENCY_RATE', null)
        if (depositType.vendor === 'LuqaPay') {
          return dispatch('userModule/getCountries', null, { root: true })
        }
      }

      if (depositType.name === 'Coinbase') {
        commit(
          'SELECTED_DEPOSIT_V_CURRENCY_TYPE',
          state.depositVCurrencyTypes[0]
        )
        commit('DEPOSIT_V_CURRENCY_EXCHANGE_QUANTITY', null)
        commit('DEPOSIT_V_CURRENCY_RATE', null)
      }

      if (depositType.type === 'thirdPayment') {
        commit('SELECTED_DEPOSIT_PRODUCT', null)

        if (depositType.showPicture) {
          const echelonPayImageSet =
            comp.financialService.deposit.echelonPayImageSet

          return echelonPayImageSet
            ? dispatch('getDepositProducts', echelonPayImageSet)
            : Promise.resolve()
        }
      }

      return Promise.resolve()
    },
    selectDepositPrice({ commit, dispatch }, payload) {
      commit('SELECTED_DEPOSIT_PRICE', payload)
      dispatch('updateDepositPrice', payload)
    },
    updateDepositBankInfoList({ commit, state, dispatch }, payload) {
      commit(
        'DEPOSIT_BANK_CARD_INFO_LIST',
        payload.map(item => ({
          name: item.bankName,
          accountName: item.accountName,
          code: item.bankCode,
          codeLabel: item.bankCodeLabel,
          no: item.bankCardNo,
          branch: item.branch,
          branchCode: item.branchCode,
          minLimitPrice: item.lowerLimit,
          maxLimitPrice: item.upperLimit,
          id: item.paymentId
        }))
      )
      dispatch('selectDepositBankCardInfo', state.depositBankCardInfoList[0])
    },
    selectDepositBankCardInfo({ commit, state }, payload) {
      commit('SELECTED_DEPOSIT_BANK_CARD_INFO', payload)
      commit(
        'DEPOSIT_MIN_LIMIT_PRICE',
        state.selectedDepositBankCardInfo.minLimitPrice
      )
      commit(
        'DEPOSIT_MAX_LIMIT_PRICE',
        state.selectedDepositBankCardInfo.maxLimitPrice
      )
    },
    updateDepositPrice({ commit, state }, payload) {
      commit('DEPOSIT_PRICE', payload)
      if (payload) {
        const index = state.depositPrices.indexOf(parseFloat(payload))
        if (index === -1) {
          commit('SELECTED_DEPOSIT_PRICE', null)
        } else {
          commit('SELECTED_DEPOSIT_PRICE', state.depositPrices[index])
        }
      } else {
        commit('SELECTED_DEPOSIT_PRICE', null)
      }
    },
    getDepositChannels(context) {
      const { rootState } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/payment/getPaymentTypeByTerminal`,
                {
                  terminal: rootState.isMobile ? '1' : '0'
                },
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    getDepositTypes(context) {
      const { state, rootState, commit, dispatch } = context
      const data = {
        terminal: rootState.isMobile ? '1' : '0'
      }
      if (state.selectedDepositChannel) {
        data.type = state.selectedDepositChannel
      }
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/payment/getType`,
                data,
                getAxiosConfig(context)
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          filter(({ data }) => data?.length > 0),
          tap(({ data }) => {
            commit('DEPOSIT_TYPES', data.map(convertDepositType))
          }),
          concatMap(() =>
            from(dispatch('selectDepositType', state.depositTypes[0]))
          )
        )
        .toPromise()
    },
    getDepositSubTypes(context, { id }) {
      const { rootState, commit, state, dispatch } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/payment/getChannel`,
                {
                  terminal: rootState.isMobile ? '1' : '0',
                  typeId: id,
                  platformType: state.selectedDepositType.name
                },
                getAxiosConfig(context)
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('DEPOSIT_SUB_TYPES', data.map(convertDepositType))
          }),
          concatMap(() =>
            from(dispatch('selectDepositSubType', state.depositSubTypes[0]))
          )
        )
        .toPromise()
    },
    getDepositBanks(context) {
      const { state } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$get(
                `/webapi/payment/v2/config/bank/list/${
                  state.selectedDepositType.key
                }`,
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    getDepositBankCardInfoList(context) {
      const { state, dispatch } = context
      const data = {}

      if (state.selectedDepositBankSubType) {
        data.bankCode = state.selectedDepositBankSubType.bankCode
        data.branchCode = state.selectedDepositBankSubType.branchCode
        data.cardNo = state.selectedDepositBankSubType.cardNo
      }
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/payment/getBankCardInfoV2`,
                data,
                getAxiosConfig(context)
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          concatMap(({ data }) =>
            from(dispatch('updateDepositBankInfoList', data))
          )
        )
        .toPromise()
    },
    getDepositBankCardSubTypes(context) {
      const { commit, dispatch, state } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/payment/getBankCardChannel`,
                {},
                getAxiosConfig(context)
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit(
              'DEPOSIT_BANK_SUB_TYPES',
              data.map(item => ({
                ...convertDepositType(item),
                bankCode: item.bankCode,
                branchCode: item.branchCode,
                cardNo: item.cardNo,
                referenceNo: item.referenceNo,
                depositNo: item.billno
              }))
            )
          }),
          concatMap(() =>
            from(
              dispatch('selectDepositBankSubType', state.depositBankSubTypes[0])
            )
          )
        )
        .toPromise()
    },
    getDepositBankCardInfoTransferInBankList(context) {
      const { rootState } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$get(
                `/webapi/user/bankCard/bankList?isoCountryCode=${
                  rootState.authModule.user.userCurrency
                }`,
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    addPayment(context, payload) {
      const { state, rootState, dispatch } = context
      const data = {
        currency_code: rootState.authModule.user.userCurrency,
        id: state.selectedDepositType.key,
        orderAmount: state.depositPrice
      }
      if (state.selectedDepositSubType) {
        data.id = state.selectedDepositSubType.key
      }
      if (
        state.selectedDepositChannel &&
        state.selectedDepositChannel === 'bankcard'
      ) {
        data.id = state.selectedDepositBankCardInfo.id // paymentId
        data.bankName = state.selectedDepositBankCardInfo.name // 存款銀行名稱
        data.accountName = state.selectedDepositBankCardInfo.accountName // 收款姓名
        data.bankCode = state.selectedDepositBankCardInfo.code // 存款銀行
        data.bankCardNo = state.selectedDepositBankCardInfo.no // 收款帳號
        data.billNo = state.selectedDepositBankCardInfo.depositNo // 存款单号
        data.transferType = state.selectedDepositBankCardInfoType // 存款方式
        data.fromBankcode = state.selectedDepositBankCardInfoTransferInBank // 轉入銀行
        data.fromDepositorName = state.depositBankCardInfoDepositName // 存款姓名
        data.createTime = state.depositBankCardInfoCreateTime
      }
      if (state.selectedDepositBank) {
        data.bankCode = state.selectedDepositBank
      }
      if (state.selectedDepositType.name === 'iPayment') {
        data.firstName = state.depositCreditCardHolderFirstName
        data.lastName = state.depositCreditCardHolderLastName
        data.country = rootState.userModule.selectedCountry
        data.city = state.depositCreditCardCity
        data.postcode = state.depositCreditCardPostalCode
        data.street = state.depositCreditCardStreet
      }
      if (state.selectedDepositType.type === 'creditCard') {
        if (state.depositCreditCardPaymentType === 'manual') {
          data.firstName = state.depositCreditCardHolderFirstName
          data.lastName = state.depositCreditCardHolderLastName

          data.cardNumber = state.depositCreditCardNumber
          data.cardExpiryMonth = state.depositCreditCardExpirationMonth
          data.cardExpiryYear = '20' + state.depositCreditCardExpirationYear
          data.cardCVV = state.depositCreditCardCVV
          data.uniqueId = state.depositCreditCardUniqueId
          data.deviceNo = state.depositCreditCardDeviceNo
          data.saveCreditCard = state.depositCreditCardSaveCreditCard
          data.cardType = state.selectedDepositType.name

          switch (
            (state.selectedDepositSubType || state.selectedDepositType).vendor
          ) {
            case 'CSNPay':
              data.phone = state.depositCreditCardPhone
              data.cardEmail = state.depositCreditCardEmail
              break
            case 'SolidPayments':
              if (state.depositCreditCardState) {
                data.state = state.depositCreditCardState
              }
              data.country = rootState.userModule.selectedCountry
              data.city = state.depositCreditCardCity
              data.postcode = state.depositCreditCardPostalCode
              data.street = state.depositCreditCardStreet
              break
            default:
              data.phone = state.depositCreditCardPhone
              data.cardEmail = state.depositCreditCardEmail
              data.country = rootState.userModule.selectedCountry
              data.city = state.depositCreditCardCity
              data.postcode = state.depositCreditCardPostalCode
              data.street = state.depositCreditCardStreet
              break
          }
        } else {
          data.creditCardUuid =
            state.selectedDepositUserCreditCard.creditCardUuid
          data.cardType = state.selectedDepositUserCreditCard.cardType
          data.deviceNo = state.depositCreditCardDeviceNo
          data.uniqueId = state.depositCreditCardUniqueId

          if (state.depositCreditCardCVV) {
            data.cardCVV = state.depositCreditCardCVV
          }
          if (state.depositCreditCardPostalCode) {
            data.postcode = state.depositCreditCardPostalCode
          }
        }
      }
      if (state.selectedDepositType.name === 'VENUS-POINT') {
        const userVenusPointAccount = getUserVenusPointAccount(rootState)
        data.thirdAccount =
          userVenusPointAccount === state.depositVenusPointAccount
            ? ''
            : state.depositVenusPointAccount
        data.thirdPaymentPwd = md5(state.depositVenusPointPassword)
      }
      if (state.selectedDepositType.name === 'VEGA') {
        const userVEGAAccount = getUserVenusPointAccount(rootState)
        data.thirdAccount =
          userVEGAAccount === state.depositVEGAAccount
            ? ''
            : state.depositVEGAAccount
        data.thirdPaymentPwd = md5(state.depositVEGAPassword)
      }
      if (state.selectedDepositType.type === 'vCurrency') {
        if (
          (state.selectedDepositSubType || state.selectedDepositType).vendor ===
          'LuqaPay'
        ) {
          data.country = rootState.userModule.selectedCountry
          data.firstName = state.depositFirstName
          data.lastName = state.depositLastName
        } else {
          data.virtualCurrency = state.selectedDepositType.name
          data.virtualCurrencyNum = String(
            state.depositVCurrencyExchangeQuantity
          )
          data.exchangeRate = String(state.depositVCurrencyRate)
        }
      }
      if (state.selectedDepositType.name === 'Coinbase') {
        data.currency_code = state.selectedDepositVCurrencyType
        if (state.depositVCurrencyExchangeQuantity === null) {
          return dispatch('getVCurrencyExchangeInfo', data)
        } else {
          data.virtualCurrencyNum = String(
            state.depositVCurrencyExchangeQuantity
          )
        }
      }
      if (['ecoPayz', 'Payz'].includes(state.selectedDepositType.name)) {
        data.firstName = state.depositFirstName
        data.lastName = state.depositLastName
      }
      if (state.selectedDepositType.type === 'bankcard') {
        data.billNo = state.selectedDepositBankSubType.depositNo
        data.receiveBankCode = state.selectedDepositBankSubType.bankCode
        data.receiveBranchCode = state.selectedDepositBankSubType.branchCode
        data.receiveCardNo = state.selectedDepositBankSubType.cardNo

        if (state.selectedDepositBankSubType.referenceNo) {
          data.referenceNo = state.selectedDepositBankSubType.referenceNo
        }
      }
      if (state.selectedDepositType.type === 'thirdPayment') {
        if (state.selectedDepositSubType?.type === 'bankcard') {
          data.receiveBankCode = state.selectedDepositSubType.bankCode
          data.receiveBranchCode = state.selectedDepositSubType.branchCode
          data.receiveCardNo = state.selectedDepositSubType.cardNo
          data.billNo = state.selectedDepositSubType.depositNo

          if (state.selectedDepositSubType.referenceNo) {
            data.referenceNo = state.selectedDepositSubType.referenceNo
          }
        }
      }

      if (state.selectedDepositUserBankInfo?.bankCode) {
        data.fromBankId = state.selectedDepositUserBankInfo.id
        data.bankCode = state.selectedDepositUserBankInfo.bankCode
        data.katakana = state.selectedDepositUserBankInfo.katakana
      }

      if (state.depositExchangeRate) {
        let amountJPY = Math.round(
          parseFloat(
            (state.depositPrice * state.depositExchangeRate).toFixed(2)
          )
        )
        if (
          state.depositPrices.length > 0 &&
          state.depositPriceCurrency === 'JPY'
        ) {
          amountJPY = state.depositPrice
          data.orderAmount = (
            state.depositPrice * state.depositExchangeRate
          ).toFixed(2)
        }
        data.amountJPY = (payload?.amountJPY || amountJPY).toString()
        data.exchangeRate = state.depositExchangeRate.toString()
      }

      if (
        (state.selectedDepositSubType || state.selectedDepositType).showPicture
      ) {
        data.productId = state.selectedDepositProduct.name
      }

      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/payment/addPayment`,
                data,
                getAxiosConfig(context, { timeout: 180 * 1000 })
              )
            )
          )
        )
        .toPromise()
    },
    getDepositStatus(context, payload) {
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/payment/getDepositStatus`,
                payload,
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    cancelDeposit(context, { billNo }) {
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/payment/doCancelDeposit`,
                {
                  billno: billNo
                },
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    getCustomPaymentInfo(context, { id, data = {} }) {
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/payment/getCusPayInfo/${id}`,
                data,
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    getDepositBankCardRate(context) {
      const { commit, state } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/payment/curBaseSetting`,
                {
                  groupCode: 'BANK_CARD_JPY_RATE_DEPOSIT',
                  currency: state.depositPriceCurrency || ''
                },
                getAxiosConfig(context, { timeout: 10 * 1000 })
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('DEPOSIT_EXCHANGE_RATE', data.rate)
            commit('DEPOSIT_DISPLAY_EXCHANGE_RATE', data.rateJPY)
          })
        )
        .toPromise()
    },
    getDepositProducts(context, payload) {
      const { commit, dispatch } = context
      commit('DEPOSIT_PRODUCTS', [])
      commit('IS_DEPOSIT_PRODUCT_LOADING', true)

      return dispatch('getImageKitFileList', `/common/deposit-${payload}`, {
        root: true
      })
        .then(data => {
          commit(
            'DEPOSIT_PRODUCTS',
            data.result.map(item => ({
              id: item.fileId,
              name:
                item.name.indexOf('.') === -1
                  ? item.name
                  : item.name.substring(0, item.name.lastIndexOf('.')),
              url: item.url
            }))
          )
        })
        .finally(() => {
          commit('IS_DEPOSIT_PRODUCT_LOADING', false)
        })
    },

    //
    // withdrawal
    //
    initWithdrawalData({ commit, dispatch, rootState }) {
      commit('SELECTED_WITHDRAWAL_THIRD_PAYMENT', null)
      commit('WITHDRAWAL_THIRD_PAYMENT_SUB_TYPES', [])
      commit('WITHDRAWAL_FEE_RATE', null)
      commit('IS_WITHDRAWAL_FEE_RATE_SHOW_ZERO', false)
      commit('WITHDRAWAL_V_CURRENCY_DESTINATION_TAG', null)
      commit('SELECTED_WITHDRAWAL_BANK_CARD', null)
      commit('PAY_PASSWORD', null)
      commit('WITHDRAWAL_PRICE', null)
      commit('WITHDRAWAL_EXCHANGE_RATE', null)
      commit('WITHDRAWAL_PRICES', [])

      return dispatch('selectWithdrawalThirdPaymentSubType', null)
    },
    getWithdrawalFormFields(context) {
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/payment/getWithdrawChannel`,
                {},
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    getWithdrawalThirdPaymentSubTypes(context) {
      const { state, commit, dispatch } = context

      const data = {}
      if (state.selectedWithdrawalThirdPayment.virtualCurrency) {
        data.currency = state.selectedWithdrawalThirdPayment.virtualCurrency
      }
      if (state.selectedWithdrawalThirdPayment.bankCode) {
        data.bankCode = state.selectedWithdrawalThirdPayment.bankCode
      }

      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/payment/getWithdrawSubChannel`,
                data,
                getAxiosConfig(context)
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('WITHDRAWAL_THIRD_PAYMENT_SUB_TYPES', data || [])
          }),
          concatMap(() =>
            from(
              dispatch(
                'selectWithdrawalThirdPaymentSubType',
                state.withdrawalThirdPaymentSubTypes.length > 0
                  ? state.withdrawalThirdPaymentSubTypes[0]
                  : null
              )
            )
          )
        )
        .toPromise()
    },
    selectWithdrawalThirdPaymentSubType({ commit }, payload) {
      commit('SELECTED_WITHDRAWAL_THIRD_PAYMENT_SUB_TYPE', payload)
      commit('THIRD_PAYMENT_PASSWORD', null)
      commit('PAY_PASSWORD', null)
      commit('WITHDRAWAL_PRICE', null)
      commit('WITHDRAWAL_V_CURRENCY_EXCHANGE_QUANTITY', 0)
      commit('WITHDRAWAL_V_CURRENCY_RATE', 0)
      commit('WITHDRAWAL_FIRST_NAME', null)
      commit('WITHDRAWAL_LAST_NAME', null)
      commit('userModule/SELECTED_COUNTRY', null, { root: true })
      if (payload) {
        commit('WITHDRAWAL_PRICES', amountStr2Arr(payload.fixedAmount))
      }
      return Promise.resolve()
    },
    getWithdrawalFeeRate(context, payload) {
      const { commit } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/payment/getWithdrawRateByPlayer`,
                {
                  opId: payload
                },
                getAxiosConfig(context)
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('WITHDRAWAL_FEE_RATE', data.rate)
            commit('HAS_WITHDRAWAL_FEE_RATE', data.showFee)
            commit('IS_WITHDRAWAL_FEE_RATE_SHOW_ZERO', data.feeEqualZero)
          })
        )
        .toPromise()
    },
    withdrawal(context, payload) {
      const { state, rootState } = context
      let data = {
        amount: state.withdrawalPrice,
        password: state.payPassword
      }
      if (['bs', 'demo', 'zh', 'st'].includes(process.env.COMP_ID)) {
        data = {
          ...data,
          tkType: ''
        }
        if (state.selectedWithdrawalType === 'bankcard') {
          data.id = state.selectedWithdrawalBankCard // id
        } else if (state.selectedWithdrawalType === 'thirdPayment') {
          const selectedWithdrawalThirdPayment = JSON.parse(
            state.selectedWithdrawalThirdPayment
          )
          data.opId = selectedWithdrawalThirdPayment.opId
          data.thirdAccount = selectedWithdrawalThirdPayment.thirdAccount
        }
        if (payload) {
          data = {
            ...data,
            ...payload
          }
        }
      } else {
        if (state.selectedWithdrawalThirdPayment) {
          data.opId = state.selectedWithdrawalThirdPayment.opId
          if (state.selectedWithdrawalThirdPaymentSubType) {
            data.opId = state.selectedWithdrawalThirdPaymentSubType.opId
          }
          if (
            state.selectedWithdrawalThirdPayment.thirdName === 'VENUS-POINT' ||
            state.selectedWithdrawalThirdPayment.thirdName === 'VEGA'
          ) {
            data.thirdPaymentPwd = md5(state.thirdPaymentPassword)
          }
          if (state.selectedWithdrawalThirdPayment.thirdName === 'Coinbase') {
            data = {
              ...data,
              virtualCurrency:
                state.selectedWithdrawalThirdPayment.virtualCurrency,
              virtualCurrencyNum: String(
                state.withdrawalVCurrencyExchangeQuantity
              ),
              exchangeRate: String(state.withdrawalVCurrencyRate)
            }
          }
          if (state.selectedWithdrawalThirdPayment.thirdType === 'vCurrency') {
            if (
              state.selectedWithdrawalThirdPaymentSubType.thirdName ===
              'LuqaPay'
            ) {
              data = {
                ...data,
                virtualCurrency:
                  state.selectedWithdrawalThirdPayment.virtualCurrency,
                userLastName: state.withdrawalLastName,
                userFirstName: state.withdrawalFirstName,
                country: rootState.userModule.selectedCountry
              }
            } else {
              data = {
                ...data,
                virtualCurrency:
                  state.selectedWithdrawalThirdPayment.virtualCurrency,
                virtualCurrencyNum: state.withdrawalVCurrencyExchangeQuantity,
                exchangeRate: state.withdrawalVCurrencyRate
              }
              if (state.withdrawalVCurrencyDestinationTag !== null) {
                data.destinationTag = state.withdrawalVCurrencyDestinationTag
              }
            }
          }
          if (
            state.selectedWithdrawalThirdPayment.thirdType === 'thirdPayment'
          ) {
            switch (state.selectedWithdrawalThirdPayment.thirdName) {
              case 'SKYPAY':
                break
              case 'pix':
                data = {
                  ...data,
                  bankCode:
                    state.selectedWithdrawalThirdPaymentSubType.bankCode,
                  userLastName:
                    state.selectedWithdrawalThirdPaymentSubType.accountLastName,
                  userFirstName:
                    state.selectedWithdrawalThirdPaymentSubType
                      .accountFirstName,
                  country: process.env.DEFAULT_COUNTRY,
                  currency: 'BRL'
                }
                break
              default:
                data = {
                  ...data,
                  bankCode:
                    state.selectedWithdrawalThirdPaymentSubType.bankCode,
                  userLastName:
                    state.selectedWithdrawalThirdPaymentSubType.accountLastName,
                  userFirstName:
                    state.selectedWithdrawalThirdPaymentSubType
                      .accountFirstName,
                  country: process.env.DEFAULT_COUNTRY,
                  currency: 'JPY',
                  amountJPY:
                    Number(state.withdrawalPrice) *
                    state.selectedWithdrawalThirdPaymentSubType.rate
                }
                break
            }
          }
        }
        if (state.selectedWithdrawalBankCard) {
          data.id = state.selectedWithdrawalBankCard.id
        }

        if (state.withdrawalExchangeRate) {
          data.amountJPY = Math.round(
            parseFloat(
              (state.withdrawalPrice * state.withdrawalExchangeRate).toFixed(2)
            )
          ).toString()
          data.exchangeRate = state.withdrawalExchangeRate.toString()
        }

        if (payload) {
          data = {
            ...data,
            ...payload
          }
        }
      }
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/payment/withdraw_new`,
                data,
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    cancelWithdrawal(context) {
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/payment/withdrawCancel`,
                {},
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    getWithdrawalBankCardRate(context) {
      const { commit, state } = context
      const data = {}
      if (state.selectedWithdrawalThirdPayment?.thirdType === 'ebank') {
        data.thirdType = state.selectedWithdrawalThirdPayment.thirdType
        data.thirdName = state.selectedWithdrawalThirdPayment.thirdName
      }
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/payment/curBaseSetting`,
                {
                  groupCode: 'BANK_CARD_JPY_RATE_WITHDRAW',
                  currency: '',
                  ...data
                },
                getAxiosConfig(context, { timeout: 10 * 1000 })
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('WITHDRAWAL_EXCHANGE_RATE', data.rate)
          })
        )
        .toPromise()
    },

    //
    // transfer
    //
    transfer(context) {
      const { state } = context
      if (state.selectedTransferOutWallet === 'USER_BALANCE') {
        // 本金戶 to 平台
        return from(refreshToken(context))
          .pipe(
            concatMap(() =>
              from(
                this.$axios.$post(
                  `/webapi/transfer/transferIn`,
                  {
                    money: state.transferPrice,
                    platform: state.selectedTransferInWallet
                  },
                  getAxiosConfig(context, { timeout: 10 * 1000 })
                )
              )
            )
          )
          .toPromise()
      } else if (state.selectedTransferOutWallet === 'USER_BONUS') {
        // 獎金戶 to 平台
        return from(refreshToken(context))
          .pipe(
            concatMap(() =>
              from(
                this.$axios.$post(
                  `/webapi/transfer/deputyTransferIn`,
                  {
                    money: state.transferPrice,
                    platform: state.selectedTransferInWallet
                  },
                  getAxiosConfig(context, { timeout: 10 * 1000 })
                )
              )
            )
          )
          .toPromise()
      } else {
        // 平台 to 本金戶
        return from(refreshToken(context))
          .pipe(
            concatMap(() =>
              from(
                this.$axios.$post(
                  `/webapi/transfer/transferOut`,
                  {
                    money: state.transferPrice,
                    platform: state.selectedTransferOutWallet
                  },
                  getAxiosConfig(context, { timeout: 10 * 1000 })
                )
              )
            )
          )
          .toPromise()
      }
    }
  },
  mutations: {
    DEPOSIT_CHANNELS(state, payload) {
      state.depositChannels = payload
    },
    SELECTED_DEPOSIT_CHANNEL(state, payload) {
      state.selectedDepositChannel = payload
    },
    DEPOSIT_TYPES(state, payload) {
      state.depositTypes = payload
    },
    SELECTED_DEPOSIT_TYPE(state, payload) {
      state.selectedDepositType = payload
    },
    DEPOSIT_SUB_TYPES(state, payload) {
      state.depositSubTypes = payload
    },
    SELECTED_DEPOSIT_SUB_TYPE(state, payload) {
      state.selectedDepositSubType = payload
    },
    DEPOSIT_BANKS(state, payload) {
      state.depositBanks = payload
    },
    SELECTED_DEPOSIT_BANK(state, payload) {
      state.selectedDepositBank = payload
    },
    DEPOSIT_BANK_SUB_TYPES(state, payload) {
      state.depositBankSubTypes = payload
    },
    SELECTED_DEPOSIT_BANK_SUB_TYPE(state, payload) {
      state.selectedDepositBankSubType = payload
    },
    DEPOSIT_BANK_CARD_INFO_LIST(state, payload) {
      state.depositBankCardInfoList = payload
    },
    SELECTED_DEPOSIT_BANK_CARD_INFO(state, payload) {
      state.selectedDepositBankCardInfo = payload
    },
    SELECTED_DEPOSIT_USER_BANK_INFO(state, payload) {
      state.selectedDepositUserBankInfo = payload
    },
    DEPOSIT_BANK_CARD_INFO_TRANSFER_IN_BANK_LIST(state, payload) {
      state.depositBankCardInfoTransferInBankList = payload
    },
    SELECTED_DEPOSIT_BANK_CARD_INFO_TRANSFER_IN_BANK(state, payload) {
      state.selectedDepositBankCardInfoTransferInBank = payload
    },
    SELECTED_DEPOSIT_BANK_CARD_INFO_TYPE(state, payload) {
      state.selectedDepositBankCardInfoType = payload
    },
    DEPOSIT_BANK_CARD_INFO_CREATE_TIME(state, payload) {
      state.depositBankCardInfoCreateTime = payload
    },
    DEPOSIT_PRODUCTS(state, payload) {
      state.depositProducts = payload
    },
    SELECTED_DEPOSIT_PRODUCT(state, payload) {
      state.selectedDepositProduct = payload
    },
    IS_DEPOSIT_PRODUCT_LOADING(state, payload) {
      state.isDepositProductLoading = payload
    },
    DEPOSIT_CREDIT_CARD_CVV(state, payload) {
      state.depositCreditCardCVV = payload
    },
    DEPOSIT_CREDIT_CARD_EXPIRATION_MONTH(state, payload) {
      state.depositCreditCardExpirationMonth = payload
    },
    DEPOSIT_CREDIT_CARD_EXPIRATION_YEAR(state, payload) {
      state.depositCreditCardExpirationYear = payload
    },
    DEPOSIT_CREDIT_CARD_HOLDER_FIRST_NAME(state, payload) {
      state.depositCreditCardHolderFirstName = payload
    },
    DEPOSIT_CREDIT_CARD_HOLDER_LAST_NAME(state, payload) {
      state.depositCreditCardHolderLastName = payload
    },
    DEPOSIT_CREDIT_CARD_NUMBER(state, payload) {
      state.depositCreditCardNumber = payload
    },
    DEPOSIT_CREDIT_CARD_STATE(state, payload) {
      state.depositCreditCardState = payload
    },
    DEPOSIT_CREDIT_CARD_CITY(state, payload) {
      state.depositCreditCardCity = payload
    },
    DEPOSIT_CREDIT_CARD_POSTAL_CODE(state, payload) {
      state.depositCreditCardPostalCode = payload
    },
    DEPOSIT_CREDIT_CARD_STREET(state, payload) {
      state.depositCreditCardStreet = payload
    },
    DEPOSIT_CREDIT_CARD_PHONE(state, payload) {
      state.depositCreditCardPhone = payload
    },
    DEPOSIT_CREDIT_CARD_EMAIL(state, payload) {
      state.depositCreditCardEmail = payload
    },
    DEPOSIT_CREDIT_CARD_SCRIPT_SRC(state, payload) {
      state.depositCreditCardScriptSrc = payload
    },
    DEPOSIT_CREDIT_CARD_UNIQUE_ID(state, payload) {
      state.depositCreditCardUniqueId = payload
    },
    DEPOSIT_CREDIT_CARD_DEVICE_NO(state, payload) {
      state.depositCreditCardDeviceNo = payload
    },
    DEPOSIT_CREDIT_CARD_SAVE_CREDIT_CARD(state, payload) {
      state.depositCreditCardSaveCreditCard = payload
    },
    DEPOSIT_CREDIT_CARD_PAYMENT_TYPE(state, payload) {
      state.depositCreditCardPaymentType = payload
    },
    SELECTED_DEPOSIT_USER_CREDIT_CARD(state, payload) {
      state.selectedDepositUserCreditCard = payload
    },
    DEPOSIT_CREDIT_CARD_TYPE(state, payload) {
      state.depositCreditCardType = payload
    },
    DEPOSIT_VENUS_POINT_ACCOUNT(state, payload) {
      state.depositVenusPointAccount = payload
    },
    DEPOSIT_VENUS_POINT_PASSWORD(state, payload) {
      state.depositVenusPointPassword = payload
    },
    DEPOSIT_VEGA_ACCOUNT(state, payload) {
      state.depositVEGAAccount = payload
    },
    DEPOSIT_VEGA_PASSWORD(state, payload) {
      state.depositVEGAPassword = payload
    },
    DEPOSIT_FIRST_NAME(state, payload) {
      state.depositFirstName = payload
    },
    DEPOSIT_LAST_NAME(state, payload) {
      state.depositLastName = payload
    },
    DEPOSIT_V_CURRENCY_TYPES(state, payload) {
      state.depositVCurrencyTypes = payload
    },
    SELECTED_DEPOSIT_V_CURRENCY_TYPE(state, payload) {
      state.selectedDepositVCurrencyType = payload
    },
    DEPOSIT_V_CURRENCY_EXCHANGE_QUANTITY(state, payload) {
      state.depositVCurrencyExchangeQuantity = payload
    },
    DEPOSIT_V_CURRENCY_RATE(state, payload) {
      state.depositVCurrencyRate = payload
    },

    DEPOSIT_MIN_LIMIT_PRICE(state, payload) {
      state.depositMinLimitPrice = payload
    },
    DEPOSIT_MAX_LIMIT_PRICE(state, payload) {
      state.depositMaxLimitPrice = payload
    },
    DEPOSIT_PRICES(state, payload) {
      state.depositPrices = payload
    },
    DEPOSIT_PRICE_CURRENCY(state, payload) {
      state.depositPriceCurrency = payload
    },
    SELECTED_DEPOSIT_PRICE(state, payload) {
      state.selectedDepositPrice = payload
    },
    DEPOSIT_PRICE_SELECT_ONLY(state, payload) {
      state.depositPriceSelectOnly = payload
    },
    DEPOSIT_BANK_CARD_INFO_DEPOSIT_NAME(state, payload) {
      state.depositBankCardInfoDepositName = payload
    },
    DEPOSIT_PRICE(state, payload) {
      state.depositPrice = payload
    },
    DEPOSIT_V_CURRENCY_DESTINATION_TAG(state, payload) {
      state.depositVCurrencyDestinationTag = payload
    },
    DEPOSIT_EXCHANGE_RATE(state, payload) {
      state.depositExchangeRate = payload
    },
    DEPOSIT_DISPLAY_EXCHANGE_RATE(state, payload) {
      state.depositDisplayExchangeRate = payload
    },
    DEPOSIT_FEE_RATE(state, payload) {
      state.depositFeeRate = payload
    },

    THIRD_PAYMENT_PASSWORD(state, payload) {
      state.thirdPaymentPassword = payload
    },
    PAY_PASSWORD(state, payload) {
      state.payPassword = payload
    },
    WITHDRAWAL_PRICE(state, payload) {
      state.withdrawalPrice = payload
    },
    WITHDRAWAL_PRICES(state, payload) {
      state.withdrawalPrices = payload
    },
    WITHDRAWAL_V_CURRENCY_DESTINATION_TAG(state, payload) {
      state.withdrawalVCurrencyDestinationTag = payload
    },
    SELECTED_WITHDRAWAL_TYPE(state, payload) {
      state.selectedWithdrawalType = payload
    },
    SELECTED_WITHDRAWAL_BANK_CARD(state, payload) {
      state.selectedWithdrawalBankCard = payload
    },
    SELECTED_WITHDRAWAL_THIRD_PAYMENT(state, payload) {
      state.selectedWithdrawalThirdPayment = payload
    },
    WITHDRAWAL_FORM_FIELDS(state, payload) {
      state.withdrawalFormFields = payload
    },
    WITHDRAWAL_THIRD_PAYMENT_SUB_TYPES(state, payload) {
      state.withdrawalThirdPaymentSubTypes = payload
    },
    SELECTED_WITHDRAWAL_THIRD_PAYMENT_SUB_TYPE(state, payload) {
      state.selectedWithdrawalThirdPaymentSubType = payload
    },
    WITHDRAWAL_FEE_RATE(state, payload) {
      state.withdrawalFeeRate = payload
    },
    HAS_WITHDRAWAL_FEE_RATE(state, payload) {
      state.hasWithdrawalFeeRate = payload
    },
    WITHDRAWAL_EXCHANGE_RATE(state, payload) {
      state.withdrawalExchangeRate = payload
    },
    IS_WITHDRAWAL_FEE_RATE_SHOW_ZERO(state, payload) {
      state.isWithdrawalFeeRateShowZero = payload
    },
    WITHDRAWAL_V_CURRENCY_EXCHANGE_QUANTITY(state, payload) {
      state.withdrawalVCurrencyExchangeQuantity = payload
    },
    WITHDRAWAL_V_CURRENCY_RATE(state, payload) {
      state.withdrawalVCurrencyRate = payload
    },
    WITHDRAWAL_FIRST_NAME(state, payload) {
      state.withdrawalFirstName = payload
    },
    WITHDRAWAL_LAST_NAME(state, payload) {
      state.withdrawalLastName = payload
    },

    SELECTED_TRANSFER_OUT_WALLET(state, payload) {
      state.selectedTransferOutWallet = payload
    },
    SELECTED_TRANSFER_IN_WALLET(state, payload) {
      state.selectedTransferInWallet = payload
    },
    TRANSFER_PRICE(state, payload) {
      state.transferPrice = payload
    }
  },
  getters: {
    depositChannels(state) {
      return state.depositChannels
    },
    selectedDepositChannel(state) {
      return state.selectedDepositChannel
    },
    depositTypes(state) {
      return state.depositTypes
    },
    selectedDepositType(state) {
      return state.selectedDepositType
    },
    depositSubTypes(state) {
      return state.depositSubTypes
    },
    selectedDepositSubType(state) {
      return state.selectedDepositSubType
    },
    depositBanks(state) {
      return state.depositBanks
    },
    selectedDepositBank(state) {
      return state.selectedDepositBank
    },
    depositBankSubTypes(state) {
      return state.depositBankSubTypes
    },
    selectedDepositBankSubType(state) {
      return state.selectedDepositBankSubType
    },
    depositBankCardInfoList(state) {
      return state.depositBankCardInfoList
    },
    selectedDepositBankCardInfo(state) {
      return state.selectedDepositBankCardInfo
    },
    selectedDepositUserBankInfo(state) {
      return state.selectedDepositUserBankInfo
    },
    depositBankCardInfoTransferInBankList(state) {
      return state.depositBankCardInfoTransferInBankList
    },
    selectedDepositBankCardInfoTransferInBank(state) {
      return state.selectedDepositBankCardInfoTransferInBank
    },
    selectedDepositBankCardInfoType: state =>
      state.selectedDepositBankCardInfoType,
    depositBankCardInfoCreateTime: state => state.depositBankCardInfoCreateTime,
    depositProducts: state => state.depositProducts,
    selectedDepositProduct: state => state.selectedDepositProduct,
    isDepositProductLoading: state => state.isDepositProductLoading,
    depositCreditCardCVV: state => state.depositCreditCardCVV,
    depositCreditCardExpirationMonth: state =>
      state.depositCreditCardExpirationMonth,
    depositCreditCardExpirationYear: state =>
      state.depositCreditCardExpirationYear,
    depositCreditCardHolderFirstName: state =>
      state.depositCreditCardHolderFirstName,
    depositCreditCardHolderLastName: state =>
      state.depositCreditCardHolderLastName,
    depositCreditCardNumber: state => state.depositCreditCardNumber,
    depositCreditCardState: state => state.depositCreditCardState,
    depositCreditCardCity: state => state.depositCreditCardCity,
    depositCreditCardPostalCode: state => state.depositCreditCardPostalCode,
    depositCreditCardStreet: state => state.depositCreditCardStreet,
    depositCreditCardPhone: state => state.depositCreditCardPhone,
    depositCreditCardEmail: state => state.depositCreditCardEmail,
    depositCreditCardScriptSrc: state => state.depositCreditCardScriptSrc,
    depositCreditCardUniqueId: state => state.depositCreditCardUniqueId,
    depositCreditCardDeviceNo: state => state.depositCreditCardDeviceNo,
    depositCreditCardSaveCreditCard: state =>
      state.depositCreditCardSaveCreditCard,
    depositCreditCardPaymentType: state => state.depositCreditCardPaymentType,
    selectedDepositUserCreditCard: state => state.selectedDepositUserCreditCard,
    depositCreditCardType: state => state.depositCreditCardType,
    depositVenusPointAccount: state => state.depositVenusPointAccount,
    depositVenusPointPassword: state => state.depositVenusPointPassword,
    depositVEGAAccount: state => state.depositVEGAAccount,
    depositVEGAPassword: state => state.depositVEGAPassword,
    depositLastName: state => state.depositLastName,
    depositFirstName: state => state.depositFirstName,
    depositVCurrencyTypes: state => state.depositVCurrencyTypes,
    selectedDepositVCurrencyTypes: state => state.selectedDepositVCurrencyTypes,
    depositVCurrencyExchangeQuantity: state =>
      state.depositVCurrencyExchangeQuantity,
    depositVCurrencyRate: state => state.depositVCurrencyRate,
    depositMinLimitPrice(state) {
      return state.depositMinLimitPrice
    },
    depositMaxLimitPrice(state) {
      return state.depositMaxLimitPrice
    },
    depositPrices(state) {
      return state.depositPrices
    },
    depositPriceCurrency(state) {
      return state.depositPriceCurrency
    },
    selectedDepositPrice(state) {
      return state.selectedDepositPrice
    },
    depositPriceSelectOnly: state => state.depositPriceSelectOnly,
    depositBankCardInfoDepositName(state) {
      return state.depositBankCardInfoDepositName
    },
    depositPrice(state) {
      return state.depositPrice
    },
    depositVCurrencyDestinationTag(state) {
      return state.depositVCurrencyDestinationTag
    },
    depositExchangeRate(state) {
      return state.depositExchangeRate
    },
    depositDisplayExchangeRate(state) {
      return state.depositDisplayExchangeRate
    },
    depositFeeRate: state => state.depositFeeRate,

    thirdPaymentPassword: state => state.thirdPaymentPassword,
    payPassword: state => state.payPassword,
    withdrawalPrice: state => state.withdrawalPrice,
    withdrawalPrices: state => state.withdrawalPrices,
    withdrawalVCurrencyDestinationTag: state =>
      state.withdrawalVCurrencyDestinationTag,
    withdrawalTypes: state => state.withdrawalTypes,
    selectedWithdrawalType: state => state.selectedWithdrawalType,
    selectedWithdrawalBankCard: state => state.selectedWithdrawalBankCard,
    selectedWithdrawalThirdPayment: state =>
      state.selectedWithdrawalThirdPayment,
    withdrawalFormFields: state => state.withdrawalFormFields,
    withdrawalThirdPaymentSubTypes: state =>
      state.withdrawalThirdPaymentSubTypes,
    selectedWithdrawalThirdPaymentSubType: state =>
      state.selectedWithdrawalThirdPaymentSubType,
    withdrawalFeeRate: state => state.withdrawalFeeRate,
    hasWithdrawalFeeRate: state => state.hasWithdrawalFeeRate,
    withdrawalExchangeRate: state => state.withdrawalExchangeRate,
    isWithdrawalFeeRateShowZero: state => state.isWithdrawalFeeRateShowZero,
    withdrawalVCurrencyExchangeQuantity: state =>
      state.withdrawalVCurrencyExchangeQuantity,
    withdrawalVCurrencyRate: state => state.withdrawalVCurrencyRate,
    withdrawalFirstName: state => state.withdrawalFirstName,
    withdrawalLastName: state => state.withdrawalLastName,

    selectedTransferOutWallet: state => state.selectedTransferOutWallet,
    selectedTransferInWallet: state => state.selectedTransferInWallet,
    transferPrice: state => state.transferPrice
  }
}
